import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Root Redirect Component
 * Checks if user is authenticated and redirects accordingly
 */
export const RootRedirect: React.FC = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  
  useEffect(() => {
    // Use full page navigation for cross-app routing (POS app is separate)
    if (!authLoading && isAuthenticated) {
      window.location.href = '/pos/business-owner-entry';
    }
  }, [isAuthenticated, authLoading]);
  
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span className="text-gray-600">Loading...</span>
        </div>
      </div>
    );
  }
  
  // If Business user is authenticated, redirect will happen via useEffect
  if (isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span className="text-gray-600">Redirecting...</span>
        </div>
      </div>
    );
  }
  
  // If not authenticated, redirect to business login
  return <Navigate to="/login" replace />;
};

